import { render } from "./SignupOld.vue?vue&type=template&id=1d74d4bc"
import script from "./SignupOld.vue?vue&type=script&lang=js"
export * from "./SignupOld.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__